import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';

const socials = [
  { label: 'Instagram', href: 'https://www.instagram.com/stagsterApp', icon: Instagram },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/stagster/', icon: Linkedin },
  { label: 'X', href: 'https://www.x.com/STAGSTERApp', icon: null },
];

const footerLinkGroups = [
  {
    title: 'Explore',
    links: [
      { label: 'Bars', href: '/stag-venues' },
      { label: 'Work', href: '/work' },
      { label: 'Radar', href: '/radar' },
    ],
  },
  {
    title: 'Info',
    links: [
      { label: 'About', href: '/about' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Safety', href: '/safety' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms', href: '/terms' },
      { label: 'Guidelines', href: '/community-guidelines' },
    ],
  },
];

export default function SharedFooter({ compact = false, className = '' }) {
  return (
    <div className={className}>
      <div className="mx-3 mt-6 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" />
      <footer className={`px-3 ${compact ? 'pb-2 pt-4' : 'pb-4 pt-5'} text-center`}>
        <p
          className="text-[10px] font-semibold uppercase tracking-[0.14em] text-white/40"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Built in India. For Solos Everywhere.
        </p>
        <div className="mt-4 grid grid-cols-3 gap-2 text-left">
          {footerLinkGroups.map((group) => (
            <div key={group.title} className="rounded-[14px] bg-white/[0.02] px-3 py-2.5">
              <p
                className="text-[10px] uppercase tracking-[0.12em] text-white/56"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                {group.title}
              </p>
              <div className="mt-2 space-y-1.5">
                {group.links.map((link) => (
                  <Link key={link.href} to={link.href} className="block text-[12px] text-white/72 transition hover:text-white">
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 flex justify-center gap-3">
          {socials.map((social) => {
            const Icon = social.icon;
            return (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/[0.04] text-white/45 transition hover:bg-white/[0.07] hover:text-white/75"
                aria-label={social.label}
              >
                {Icon ? <Icon className="h-4.5 w-4.5" /> : <span className="text-sm font-semibold tracking-[0.04em]">X</span>}
              </a>
            );
          })}
        </div>
        <div className="mx-auto mt-5 h-px w-24 bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" />
        <p className="mx-auto mt-4 max-w-xs text-[10px] leading-relaxed text-white/50">
          <span className="font-bold tracking-wider text-white">STAGSTER</span>
          <br />
          All rights reserved. A product of <a href="https://www.stagsterlabs.com" target="_blank" rel="noreferrer" className="font-semibold text-white/70 underline hover:text-white">STAGSTER Labs LLP</a>
        </p>
      </footer>
    </div>
  );
}
